const DOMAIN = '.bj33smarter.com';

export function isBj33SmarterDomain() {
  return window.location.hostname.endsWith('bj33smarter.com');
}

export function cookieAttributes() {
  const a = ['Path=/'];
  if (isBj33SmarterDomain()) a.push(`Domain=${DOMAIN}`);
  if (window.location.protocol === 'https:') {
    a.push('Secure', 'SameSite=None');
  } else {
    a.push('SameSite=Lax');
  }
  return a.join('; ');
}

export function setDomainCookie(name: string, value: string) {
  document.cookie = `${name}=${encodeURIComponent(value)}; ${cookieAttributes()}`;
}

export function removeDomainCookie(name: string) {
  const expire = 'Expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = `${name}=; ${expire}; Path=/`;
  if (isBj33SmarterDomain()) {
    document.cookie = `${name}=; ${expire}; Path=/; Domain=${DOMAIN}`;
  }
}

export function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
  return m ? decodeURIComponent(m[1]) : null;
}
